module.exports = __webpack_public_path__ + "static/media/slack.9deeca1a.svg";